import { Action } from '@ngrx/store';
import { UserVerificationState } from '../state/verification.state';
import {
    IdentityVerificationStatus,
    PaymentVerification,
    UpdateUserVerification,
    UserVerification,
} from '../models/verifications.model';

export enum VerificationActions {
    successVerification = '[VerificationActions] Success',
    failVerification = '[VerificationActions] Fail',
    clearVerification = '[VerificationActions] Clear',
    updatePaymentSystemVerification = '[VerificationActions] UpdatePs',
    updateIdentityVerification = '[VerificationActions] UpdateId',
    getUserVerification = '[VerificationActions] Get',
    successIdentityVerification = '[VerificationActions] Success Identity',
}

export class SuccessVerification implements Action {
    readonly type: string = VerificationActions.successVerification;
    constructor(public payload: Partial<UserVerificationState>) {}
}

export class FailVerification implements Action {
    readonly type: string = VerificationActions.failVerification;
    constructor(public payload: string) {}
}

export class ClearVerification implements Action {
    readonly type: string = VerificationActions.clearVerification;
}

export class UpdatePaymentSystemVerification implements Action {
    readonly type: string = VerificationActions.updatePaymentSystemVerification;
    constructor(public payload: PaymentVerification) {}
}

export class UpdateIdentityVerification implements Action {
    readonly type: string = VerificationActions.updateIdentityVerification;
    constructor(public payload: UpdateUserVerification) {}
}

export class SuccessIdentityVerification implements Action {
    readonly type = VerificationActions.successIdentityVerification;
    constructor(
        public payload: { identityVerification: IdentityVerificationStatus }
    ) {}
}

export class GetUserVerification implements Action {
    readonly type: string = VerificationActions.getUserVerification;
    constructor(public payload: UserVerification) {}
}

export type VerificationSubmitActions =
    | SuccessVerification
    | FailVerification
    | ClearVerification
    | UpdatePaymentSystemVerification
    | UpdateIdentityVerification
    | SuccessIdentityVerification;
